// src/components/giftcardratesTable/GiftCardRateTable.jsx
import React, { useState } from "react";
import "./giftcardratetable.css";
import Button from "../button/Button";
import LazyLoad from "react-lazyload";

// Import currency flags
import UK from "../../assets/UK-flag.png";
import USD from "../../assets/USD.png";
import CAD from "../../assets/CAD.png";
import AUD from "../../assets/AUD.png";
import NZD from "../../assets/NZD.png";
import CHF from "../../assets/CHF.png";
import SGD from "../../assets/SGD.png";
import EUR from "../../assets/EUR.png";

const currencyFlags = { USD, UK, CAD, AUD, NZD, CHF, SGD, EUR };

const GiftCardRateTable = ({ logo, cardName, list }) => {
  const [currencyIndex, setCurrencyIndex] = useState(0);
  const currentCurrencyList = list?.[currencyIndex]?.list || [];

  return (
    <div
      className="container my-4 p-4 shadow rounded-4 GiftCard_card"
      style={{ width: "85%", border: "0.5px solid #BFBFBF" }}
    >
      {/* Header */}
      <h4>{cardName || "Gift Card"}</h4>

      {/* Currency flags + calculator button */}
      <div className="row align-items-center mb-4">
        {/* Flags */}
        <div className="col-12 col-md-8">
          <div className="flag-container d-flex flex-wrap justify-content-center justify-content-md-start align-items-center gap-2 mt-2">
            {(list || []).map((item, index) => (
              <div
                key={index}
                className={`flag ${currencyIndex === index ? "active" : ""}`}
                onClick={() => setCurrencyIndex(index)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={currencyFlags[item.currency] || ""}
                  alt={item.currency}
                  style={{ width: "20px", height: "auto", marginRight: "5px" }}
                />
                {item.currency}
              </div>
            ))}
          </div>
        </div>

        {/* Calculator Button */}
        <div className="col-12 col-md-4 d-flex justify-content-md-end justify-content-center mt-2 mt-md-0">
          <Button
            className="btn w-50 w-md-50 mbtn d-flex align-items-center justify-content-center"
            id="calculateBtn"
            style={{
              backgroundColor: "#B3E516", // brand light green
              color: "#000",               // black text
              border: "none",
              borderRadius: "8px",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#99cc13")} // slightly darker hover
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#B3E516")}
            onClick={() =>
              (window.location.href =
                "https://dashboard.regiftme.ng//sell?type=calculate")
            }
          >
            <i className="bi bi-calculator me-2"></i>Calculate
          </Button>
        </div>
      </div>

      {/* Main content */}
      <div className="row">
        <div className="col-12 col-md-3 text-center mb-3 mb-md-0">
          <LazyLoad>
            <img
              src={logo}
              alt="GiftCard"
              className="w-100 img-fluid rounded hover-effect cardImg"
            />
          </LazyLoad>
        </div>

        <div className="col-12 col-md-9">
          {/* Desktop Table */}
          <div className="desktopTable" style={{ overflowX: "auto" }}>
            <table
              className="table rounded-table text-center"
              style={{ border: "0.5px solid #BFBFBF" }}
            >
              <tbody>
                <tr>
                  <td className="fw-bold p-4">Face Value</td>
                  {currentCurrencyList.map((item, index) => (
                    <td key={index} className="p-4">{item.name}</td>
                  ))}
                </tr>
                <tr>
                  <td className="fw-bold p-4">Rate</td>
                  {currentCurrencyList.map((item, index) => (
                    <td key={index} className="p-4">{item.rate ? `${item.rate}₦/$` : "-"}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

          {/* Mobile Table */}
          <div className="mobileTable mt-4" style={{ display: "none" }}>
            <table
              className="table rounded-table text-center"
              style={{ border: "0.5px solid #BFBFBF" }}
            >
              <thead>
                <tr>
                  <th className="p-4">Face Value</th>
                  <th className="p-4">Rate</th>
                </tr>
              </thead>
              <tbody>
                {currentCurrencyList.map((item, index) => (
                  <tr key={index}>
                    <td className="p-4">{item.name}</td>
                    <td className="p-4">{item.rate ? `${item.rate}₦/$` : "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftCardRateTable;
